import { API_ENDPOINT } from "../utilities/constants";
import axios from "axios";

const getSnapShotDetail = async (location_code) => {
  const response = await axios.get(API_ENDPOINT.SNAPSHOT, { params: { location_code } });
  return response.data;
};

const saveSnapShotDetail = async (data) => {
  return axios.post(API_ENDPOINT.SNAPSHOT, data);
};
export default { getSnapShotDetail, saveSnapShotDetail };
